import axiosInstance from "../../../axios";
import config from "../../../config";

export const createUserInfoSlice = (set, get) => ({
    userInfo: {
        loading: false,
        data: [],
    },
    getTicketUserInfo: async (param) => {
        const token = get().business.currentBusiness.token;
        set(state => ({ userInfo: { ...state.userInfo, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/user-info/${param}`,
                headers: { token }
            });
            set(state => ({ userInfo: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ userInfo: { ...state.userInfo, loading: false } }));
        }
    }
});
